<template>
	<div class="mall-goods-container">
		<div class="mall-goods-detail">
			<!-- 返回按钮 -->
			<div class="back-bar">
				<el-button type="text" class="back-btn" @click="handleGoBack">
					<i class="el-icon-arrow-left"></i>
					返回
				</el-button>
			</div>

			<!-- 上方：商品信息 -->
			<div class="goods-info-section">
				<!-- 左侧：图片轮播 -->
				<div class="goods-gallery">
					<div class="main-image">
						<img :src="mainImage" :alt="goodsInfo.title" />
					</div>
				</div>

				<!-- 右侧：商品信息 -->
				<div class="goods-meta">
					<h1 class="goods-title">{{ goodsInfo.title }}</h1>
					<div class="goods-tags">
						<el-tag v-for="(tag, index) in goodsInfo.tags" :key="index" size="small" type="success" class="meta-tag">
							{{ tag }}
						</el-tag>
					</div>

					<div class="meta-list">
						<div class="meta-item">
							<span class="meta-label">商品价格：</span>
							<span class="meta-value">
								首页头条：50000 / 年 ；30000/6 个月 ；20000/3 个月 风采专栏：30000 / 年 ；20000/6 个月 ；15000/3 个月
							</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">所属类目：</span>
							<el-tag v-for="(cat, index) in goodsInfo.categories" :key="index" size="small" type="primary" class="meta-tag">
								{{ cat }}
							</el-tag>
						</div>
						<div class="meta-item">
							<span class="meta-label">发货时间：</span>
							<span class="meta-value highlight-text">7 个工作日</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">发货约定：</span>
							<span class="meta-value">购买商品服务后线上交付</span>
						</div>
					</div>

					<!-- 联系我们 -->
					<!-- <div class="contact-box">
						<div class="contact-left">
							<i class="el-icon-phone-outline contact-icon"></i>
							<div class="contact-info">
								<div class="contact-label">联系我们</div>
								<div class="contact-phone">{{ goodsInfo.contactPhone || 'xxx（请填写联系方式）' }}</div>
							</div>
						</div>
						<el-button type="text" class="copy-btn" @click="handleCopyPhone">
							<i class="el-icon-document-copy"></i>
							复制信息
						</el-button>
					</div> -->

					<!-- 操作按钮 -->
					<div class="action-btns">
						<el-button type="primary" size="medium" class="consult-btn" @click="handleConsult">立即购买</el-button>
						<el-button type="warning" size="medium" class="cart-btn" @click="handleAddCart">
							<i class="el-icon-shopping-cart-2"></i>
							加入购物车
						</el-button>
					</div>
				</div>
			</div>

			<!-- 下方：服务详情 -->
			<div class="service-detail-section">
				<div class="section-header">
					<div class="section-tab active">服务详情</div>
				</div>
				<div class="detail-content">
					<h3>服务介绍</h3>
					<p>
						本服务专为全省住建领域企业精心打造，致力于在湖北建设信息网这一权威平台的首页、频道页等核心位置，全面且精准地展示企业风采。借助此服务，企业能够以直观且极具吸引力的方式，集中呈现丰富多元的企业信息，其中企业标志性
						icon 作为重要视觉元素，将进一步强化企业的独特形象，助力企业在竞争激烈的市场中脱颖而出，高效触达目标客户群体。
					</p>
					<p>
						湖北建设信息网平台全面覆盖湖北省住建行业全产业链，拥有强大的影响力与广泛的受众群体，无疑是住建领域企业展示风采、提升知名度与美誉度的绝佳平台。
					</p>
					<h3>展示内容</h3>
					<p>投放展示内容丰富且具有针对性，涵盖但不限于以下关键要素，企业可依据自身实际需求灵活进行配置</p>
					<p>
						企业 icon 醒目展示：以突出、显眼的方式展示企业
						icon，作为企业形象的重要标识，确保在第一时间吸引目标客户的注意力，强化企业的视觉记忆点。
					</p>
					<p>基础企业信息呈现：全面展示企业名称、成立时间、发展历程等基础信息，让客户对企业的发展脉络有清晰的了解。</p>
					<p>
						企业核心价值观与文化理念：精准传达企业秉持的核心价值观与独特的文化理念，使客户深入理解企业的内在精神，增强对企业的认同感与信任感。
					</p>

					<h3>企业力量彰显</h3>
					<p>
						团队实力：展示企业核心团队成员的专业背景、行业经验以及所获荣誉，凸显团队的专业素养与创新能力，让客户相信企业具备强大的智力支持与执行能力。
					</p>
					<p>
						技术与资源优势：介绍企业拥有的先进技术、专利成果、特殊资质以及丰富的行业资源，展现企业在技术创新与资源整合方面的实力，为客户传递企业在行业内的竞争优势。
					</p>
					<p>
						企业规模与布局：通过数据和图表展示企业的规模，如员工数量、办公场地面积、分支机构分布等信息，体现企业的雄厚实力与广泛的市场覆盖，让客户对企业的整体实力有直观认知。
					</p>

					<h3>核心优势</h3>
					<p>
						精准触达：依托住建行业垂直流量的独特优势，实现对目标客户群体的精准定位与高效触达，客户精准度极高，确保宣传资源得到充分且有效的利用。
					</p>
					<p>
						数据可视：为企业提供实时的曝光量、浏览量数据监测服务，使企业对展示效果一目了然，能够随时掌握展示动态，为后续的品牌建设与市场策略调整提供有力的数据支持。
					</p>
					<p>
						一对一服务：针对企业风采展示内容，我们提供专属的一对一服务，从展示内容的策划、设计到发布，全程精心雕琢，充分考虑企业的个性化需求，确保展示效果达到最佳。
					</p>
					<p>
						高性价比：投放至湖北建设信息网（住建全领域办事平台），我们以合理的价格提供优质的展示服务，让企业的每一份投入都能获得超值回报，真正实现投有所值。
					</p>

					<h3>服务流程</h3>
					<p>
						下单购买：用户需在线上选购企业风采展示服务，并详细填写欲展示的相关企业信息，包括企业
						icon、企业力量及特色内容等资料，确认无误后完成订单支付操作。
					</p>
					<p>付款核对：财务部门将在 1 个工作日内对用户的支付状态进行认真核对，确保支付环节准确无误。</p>
					<p>信息核对：宣传部工作人员会在 2 个工作日内，仔细核对企业提供的信息以及相关资料，保证信息的真实性、完整性与准确性。</p>
					<p>
						展示发布：宣传部工作人员依据审核通过的信息与资料，精心设计并制作符合平台风格与企业需求的展示页面，确保展示效果达到最佳。
					</p>
					<p>确认发货：商家根据展示服务的实际发布情况，及时处理发货状态，向用户反馈服务进展。</p>
					<p>确认收货：展示内容发布后，用户可在湖北建设信息网的对应位置查看相关展示页面，在确认无误后，进行订单确认收货操作。</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 商城商品详情页
	 */
	export default {
		name: 'MallGoodsDetail',
		data() {
			return {
				activeImageIndex: 0,
				goodsInfo: {
					title: '企业风采投放',
					images: [require('@/assets/mall/goods/goods-corporate.png')],
					tags: ['企业风采投放'],
					categories: ['品牌宣传营销服务', '企业风采展示定制'],
					price: '400元/年',
					contactPhone: '1859234781'
				}
			}
		},
		computed: {
			mainImage() {
				return this.goodsInfo.images[this.activeImageIndex] || this.goodsInfo.images[0]
			}
		},
		methods: {
			// 返回上一页
			handleGoBack() {
				this.$router.back()
			},
			// 切换主图
			handleSwitchImage(index) {
				this.activeImageIndex = index
			},
			// 复制联系方式
			handleCopyPhone() {
				const phone = this.goodsInfo.contactPhone || ''
				if (!phone) {
					this.$message.warning('暂无联系方式')
					return
				}
				if (navigator.clipboard) {
					navigator.clipboard
						.writeText(phone)
						.then(() => {
							this.$message.success('复制成功')
						})
						.catch(() => {
							this.$message.error('复制失败')
						})
				} else {
					// 降级方案
					const input = document.createElement('input')
					input.value = phone
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
					this.$message.success('复制成功')
				}
			},
			// 立即咨询
			handleConsult() {
				// this.$message.info('咨询功能开发中')
				this.$router.push({
					path: '/mallStore/purchase',
					query: {
						displaySectorType: '2'
					}
				})
			},
			// 加入购物车
			handleAddCart() {
				// this.$message.success('已加入购物车')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/views/mall/goodsDetail/goodDetail.scss';
</style>
